module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Reign-Of-Fire.dc65bb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Reign-Of-Fire.jpg
// module id = By7s
// module chunks = 0